import { ShoppingCart } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export const EmptyCart = () => {
  const { t } = useLanguage();

  return (
    <div className="flex-1 flex items-center justify-center">
      <div className="text-center" role="status" aria-live="polite">
        <ShoppingCart 
          className="h-12 w-12 text-muted-foreground mx-auto mb-4" 
          aria-hidden="true"
        />
        <p className="text-muted-foreground">
          {t("Your cart is empty", "Tu carrito está vacío")}
        </p>
      </div>
    </div>
  );
};
